import { PortalManager } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import { GLOBAL_AI_PORTAL_LAYER_Z_INDEX } from '../CustomDash/constants/panelWidths';

/**
 * Re-stamps every Chakra portal opened from this subtree (chart tooltips,
 * popovers, menus) to `GLOBAL_AI_PORTAL_LAYER_Z_INDEX` — the app tooltip tier —
 * so a chart tooltip inside the AI chat renders alongside normal app tooltips.
 *
 * The app root's `ChakraProvider` sets `portalZIndex={40}` (main.tsx), which
 * wraps every default Chakra portal in a `z-index: 40` container. The AI chat
 * drawer sits just below that (`GLOBAL_AI_OVERLAY_Z_INDEX` 39) so modals
 * overlay it, which means a chart tooltip would already clear the drawer at 40;
 * this layer lifts it to the tooltip tier (1800) for parity with the rest of
 * the app. `portalZIndex` is itself just a root-level `PortalManager`, and
 * Chakra portals resolve the NEAREST manager, so mounting one here overrides
 * the z-index for portals opened from this subtree only; the rest of the app
 * keeps the root value.
 */
export const GlobalAiPortalLayer = ({ children }: PropsWithChildren) => (
  <PortalManager zIndex={GLOBAL_AI_PORTAL_LAYER_Z_INDEX}>
    {children}
  </PortalManager>
);
